import { observer } from 'mobx-react-lite'
import { formatJobsTableStatus } from '@/features/jobs/list/jobs-table-status'
import {
  formattedJobScopeChangeRequestStatus,
  formattedProgressionStep,
  formattedProviderCutAmount,
  formattedTotalPrice,
} from '@/features/jobs/list/jobs-table-columns'
import { type SearchableJob } from '@/features/jobs/list/SearchableJob'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'
import { JobsTableCells } from '@/features/jobs/list/components/JobManagement/JobsTable/JobsTableRow'
import { mapPrimaryCellProps } from '@/features/jobs/list/components/JobManagement/JobsTable/PrimaryCellContainer'

export interface JobsTableCellContainerProps {
  vm: JobManagementViewModel
  job: SearchableJob
}

export const JobsTableCellContainer = observer(function JobsTableCellContainer({
  vm,
  job,
}: JobsTableCellContainerProps) {
  return (
    <JobsTableCells
      columnIds={vm.columnsVm.visibleColumnIds}
      values={{
        id: job.id,
        primary: mapPrimaryCellProps(job, vm.getLatestOpenTicketForJob(job)),
        shortId: job.shortId,
        legendName: job.legendName,
        workspace: {
          title: job.workspace?.name,
          image: job.workspace?.branding?.logos?.icon,
        },
        status: formatJobsTableStatus(job.status, job.resolution),
        payout: formattedProviderCutAmount(job),
        total: vm.canViewJobTotal(job) ? formattedTotalPrice(job) : '',
        progressionStep: formattedProgressionStep(job),
        scopeChangeStatus: formattedJobScopeChangeRequestStatus(
          job.scopeChangeStatus,
        ),
        clientTeamName: job.clientTeamName,
        clientChampion: {
          title: job.championClient?.displayName,
          image: job.championClient?.avatar,
          imageFallback: job.championClient?.avatarFallback,
        },
        clientChampionEmail: job.championClient?.email,
        proChampion: {
          title: job.championPro?.displayName,
          image: job.championPro?.avatar,
          imageFallback: job.championPro?.avatarFallback,
        },
        proChampionEmail: job.championPro?.email,
        isRequestedPro: job.isRequestedPro ? 'Yes' : 'No',
        dateCreated: job.dateCreated,
        dateSubmitted: job.dateSubmitted,
        dateClaimed: job.dateAccepted,
        isCompleted: job.status === 'Closed',
        dateCompleted: job.dateClosed,
        dateAdvanceAllowed: job.dateAdvanceAllowed,
        dateLastProMessageActivity: job.dateLastProMessageActivity,
        dateLastClientMessageActivity: job.dateLastClientMessageActivity,
        dateLastRelationshipManagerMessageActivity:
          job.dateLastRelationshipManagerMessageActivity,
      }}
      density={vm.columnsVm.density}
      isSelected={vm.selectionVm.isSelectedForActions(job)}
      onToggleSelected={() => vm.selectionVm.toggleJobSelectionForActions(job)}
    />
  )
})
